module.exports = __webpack_public_path__ + "img/ls.59c2717c.svg";